import CommonSettings from './CommonSettings'

export default function HTMLSettings({ block, onUpdate }) {
  const { settings } = block

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>HTML Code</h4>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Custom HTML
        </label>
        <textarea
          value={settings.htmlContent || ''}
          onChange={(e) => onUpdate({ htmlContent: e.target.value })}
          rows={12}
          placeholder="<div>Your HTML here...</div>"
          style={{
            width: '100%',
            fontSize: '0.8rem',
            padding: '0.75rem',
            fontFamily: "'Courier New', monospace",
            resize: 'vertical',
            lineHeight: '1.5'
          }}
        />
        <span style={{
          fontSize: '0.75rem',
          color: 'var(--color-text-muted)',
          marginTop: '0.5rem',
          display: 'block'
        }}>
          Use inline styles for email compatibility
        </span>
      </div>

      <div style={{
        padding: '0.75rem',
        backgroundColor: 'rgba(99, 102, 241, 0.1)',
        borderRadius: 'var(--radius-md)',
        fontSize: '0.75rem',
        color: 'var(--color-text-secondary)',
        lineHeight: '1.5'
      }}>
        <strong>⚠️ Tips:</strong>
        <ul style={{ margin: '0.5rem 0 0 1.25rem', paddingLeft: 0 }}>
          <li>Use inline CSS styles</li>
          <li>Avoid external stylesheets</li>
          <li>Test in email clients</li>
          <li>Keep structure simple</li>
        </ul>
      </div>

      <CommonSettings settings={settings} onUpdate={onUpdate} />
    </div>
  )
}
